import { ROUTE_SIGN_IN_VERIFY_OTP } from '@/constants/routes';
import setTitleFromLoader from '@/utils/routing/set-title';
import { RouteObject } from 'react-router-dom';
import Page from './verify-otp.page';

export const routeVerifyOTP: RouteObject = {
  path: ROUTE_SIGN_IN_VERIFY_OTP,
  Component: Page,
  loader: setTitleFromLoader('Verify your email'),
};
